import React, { useRef } from "react";
import QRCode, { QRCodeProps } from "react-qr-code";
import { useSingleConnectorV2 } from "../../../hooks/useConnectors";
import Button from "../../../../../common/components/atom/Button/Button";
import { JWayIcon } from "../../../../../common/assets/JWayIcons";

export type QRCodeConnectorProps = Omit<QRCodeProps, "value"> & {
  id?: string;
  withDownload?: boolean;
};

export const QRCodeConnector = ({
  id,
  style,
  ...otherProps
}: QRCodeConnectorProps) => {
  const { singleConnectorQuery } = useSingleConnectorV2({ connectorId: id });
  const svgRef = useRef<SVGSVGElement>(null);


  const textQRCode =
    singleConnectorQuery?.data?.b_connector_slug


  const handleDownload = () => {
    const svg = svgRef.current;
    if (!svg) return;

    // Convertir le SVG en image PNG via un canvas
    const serializer = new XMLSerializer();
    const svgString = serializer.serializeToString(svg);
    const svg64 = btoa(unescape(encodeURIComponent(svgString)));
    const image64 = `data:image/svg+xml;base64,${svg64}`;
    const img = new window.Image();
    img.onload = function () {
      const canvas = document.createElement("canvas");
      canvas.width = svg.width.baseVal.value || 256;
      canvas.height = svg.height.baseVal.value || 256;
      const ctx = canvas.getContext("2d");
      if (ctx) {
        ctx.fillStyle = "#fff"; // fond blanc
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        const pngUrl = canvas.toDataURL("image/png");
        const link = document.createElement("a");
        link.href = pngUrl;
        link.download = "qrcode.png";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    };
    img.src = image64;
  };
  return <>
  {singleConnectorQuery?.data?.b_connector_slug && <div style={{...style, display: "flex" , flexDirection: "column", justifyContent: "center", alignItems: "center"}}><QRCode   style={style} ref={svgRef} {...(otherProps as any)} value={textQRCode} />
    <div style={{height: "20px"}}/>
    <Button onClick={handleDownload} variant="tertiary"><div style={{display: "flex", gap:"10", }}>Télécharger <div style={{marginLeft: "10px"}}><JWayIcon type="download-icon" size={14} color="gray" ></JWayIcon></div></div></Button>
  </div>}
  </>;
};
